import React, { useEffect, useState, useRef } from 'react';
import { ApiCore } from '../../api';
import styles from './laborAgreement.module.scss';
import SignContainer from '../../component/sign/signContainer.jsx';
import { Toast } from 'antd-mobile';
import utils from '../../utils/utils';
import OSS from "ali-oss";
const api = new ApiCore();

function LaborAgreement(props: any) {

    const [renderContent, setRenderContent] = useState('');
    const [signImgUrl, setSignImgUrl] = useState('');
    const [imgHtml, setImgHtml] = useState('');
    const [showSignBtn, setShowSignBtn] = useState(false);
    const [showConfirmBtns, toShowConfirmBtns] = useState(false);
    const [signCode, setSignCode] = useState<any>();
    // 获取OSS访问令牌
    const [ossData, setOssData] = useState<any>({});
    const mSignRef = useRef<any>();

    useEffect(() => {
        document.title = '服务协议';
        initData();
        return () => {
        }
    }, [])

    /**
     * 获取OSS访问令牌
     */
    const getOssData = () => {
        api.GetCaseSts().then((res: any) => {
            if (res.code == 0) {
                if (!res.data) {
                    return
                }
                setOssData(res.data)
            }
        })
    };

    /**
     * 提取上传类型
     * @param {*} json 
     * @returns 
     */
    const filterPathPre = (json: any, type?: any) => {
        let newJson = json;
        let data: any = [];
        data = newJson.pathPre.split(',')
        data.map((i: any) => {
            if (i.includes(type)) {
                newJson.pathPre = i;
            }
        })
        return newJson;
    }

    const dataURLtoFile = (dataURI: any, type: string) => {
        let binary = atob(dataURI.split(',')[1]);
        let array = [];
        for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], { type: type });
    }

    const initData = () => {
        let _urlParam = utils.getUrlParams() || {};
        let _code: any = _urlParam.code;
        let _preSign: any = _urlParam.isPreSign;
        let _needView: any = _urlParam.needView;
        if (_needView && _code) {
            // 完成阅读
            api.toUserAgreementRead({
                code: _code
            });
        }
        if (_code) {
            setSignCode(_code);
            getOssData();
            api.GetLaborUserAgreementDetail(_code).then((res: any) => {
                if (res.code == 0) {
                    let _data = res.data || {};
                    let preSignImg = sessionStorage.getItem('LaborPreSignImgUrl');
                    let contentInfo = _data.content;
                    setRenderContent(contentInfo);
                    if (contentInfo) {
                        let toContent = '';
                        if (_preSign == '1' && preSignImg) {
                            // 预签名不展示按钮
                            let imgHtml = `<img style="width: 100px; margin-bottom: -22px;" src="${preSignImg}" />`;
                            setImgHtml(imgHtml);
                            toContent = contentInfo.replace('${sign}', imgHtml);
                        } else {
                            if (_data.status == 0) {
                                setShowSignBtn(true);
                            }
                            toContent = contentInfo.replace('${sign}', '');
                        }
                        innerHtmlRender(toContent);
                    }
                }
            });
        }
    }

    const innerHtmlRender = (val: string) => {
        const _dom = document.getElementById('labor_service_articles_content');
        if (_dom) {
            _dom.innerHTML = val;
        }
    }

    const updateSignUrl = (imgUrl: any) => {
        setSignImgUrl(imgUrl);
        if (renderContent) {
            let imgHtml = `<img style="width: 100px; margin-bottom: -22px;" src="${imgUrl}" />`;
            setImgHtml(imgHtml);
            let toContent = renderContent.replace('${sign}', imgHtml);
            innerHtmlRender(toContent);
            toHideSignBtn();
            toShowConfirmBtns(true);
        }
    }

    const toHideSignBtn = () => {
        setShowSignBtn(false);
    }

    const toSign = () => {
        mSignRef.current && mSignRef.current.toShowModal();
    }

    const reSign = () => {
        mSignRef.current && mSignRef.current.toShowModal({
            resign: true
        });
    }

    const confirmSubmit = () => {
        const _signedBefore = mSignRef.current.getIsDrawed();
        if (!_signedBefore) {
            Toast.info('请签名后提交', 0.8);
            return;
        }
        const imgUrl = signImgUrl;
        let client = new OSS({ ...filterPathPre(ossData, 'image') });
        let blob = dataURLtoFile(imgUrl, 'image/jpeg')
        let file = new File([blob], (new Date()).getTime() + '.jpg')
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (e) => {
            const path = `${ossData.pathPre}register/agreement/sign/${(new Date()).getTime()}.jpg`;
            // oss上传
            client.put(
                path,
                file,
            ).then((res: any) => {
                let url = (res && res.url) || '';
                setSignImgUrl(url);
                let imgHtml = `<img style="width: 100px; margin-bottom: -22px;" src="${url}" />`;
                setImgHtml(imgHtml);
                signSubmit(imgHtml);
            })
                .catch((err: any) => {
                    Toast.fail('生成签名图片失败，请重新签名！', 1);
                })
        };
    }

    // 提交签名数据
    const signSubmit = (signHtml = '') => {
        api.toSignLaborUserAgreement({
            code: signCode,
            sign: signHtml
        }).then((res: any) => {
            if (res.code == 0) {
                Toast.success('签名成功');
                toHideSignBtn();
                toShowConfirmBtns(false);
            } else {
                Toast.fail(res.message || '签名失败');
            }
        })
    }

    return (
        <div className={styles.laborAgreement_content}>
            <div className={styles.content_wrap} id='labor_service_articles_content'></div>
            <SignContainer ref={mSignRef} updateSignUrl={updateSignUrl} ></SignContainer>
            {
                showSignBtn &&
                <div className={styles.btn_bottom} onClick={toSign}>立即签名</div>
            }
            {
                showConfirmBtns &&
                <div className={styles.btns_confirm}>
                    <div className={styles.btn_cancel} onClick={reSign}>重新签名</div>
                    <div className={styles.btn_confirm} onClick={confirmSubmit}>确认并提交</div>
                </div>
            }
        </div>
    )
}

export default LaborAgreement;